<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    enter-active-class="transition duration-200 ease-in"
    enter-from-class="opacity-0 -translate-y-3 scale-95"
    enter-to-class="opacity-100 translate-y-0 scale-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0 scale-100"
    leave-to-class="opacity-0 -translate-y-2 scale-95"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
